export default "__VITE_ASSET__Dxhp$7Qv__"